module.exports = __webpack_public_path__ + "static/media/veikals_paka_2.33000e76.png";